// extracted by mini-css-extract-plugin
export var closeButton = "_1b-3";
export var header = "_1b-0";
export var link = "_1b-1";
export var retryButton = "_1b-2";